import React from 'react';
import DateUtils from '../../utils/date';
import withTheme from '../../theme/withTheme';
import { isYearAndMonthViews, isYearOnlyView } from '../helpers';
import { ToolbarContainer, ToolbarButton } from './styles';
var utils = new DateUtils();
var CalendarToolbar = function CalendarToolbar(_ref) {
  var date = _ref.date,
    views = _ref.views,
    setOpenView = _ref.setOpenView,
    openView = _ref.openView,
    theme = _ref.theme;
  var isYearOnly = isYearOnlyView(views);
  var isYearAndMonth = isYearAndMonthViews(views);
  return /*#__PURE__*/React.createElement(ToolbarContainer, {
    isYearOnly: isYearOnly,
    theme: theme
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    theme: theme,
    role: "button",
    variant: "year",
    isYearOnly: isYearOnly,
    onClick: function onClick() {
      return setOpenView('year');
    },
    selected: openView === 'year'
  }, utils.getYearText(date)), !isYearOnly && !isYearAndMonth && /*#__PURE__*/React.createElement(ToolbarButton, {
    theme: theme,
    role: "button",
    onClick: function onClick() {
      return setOpenView('date');
    },
    selected: openView === 'date'
  }, utils.getDatePickerHeaderText(date)), isYearAndMonth && /*#__PURE__*/React.createElement(ToolbarButton, {
    theme: theme,
    role: "button",
    onClick: function onClick() {
      return setOpenView('month');
    },
    selected: openView === 'month'
  }, utils.getMonthText(date)));
};
export default withTheme(CalendarToolbar);